// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Member List Styles
 * Modern, responsive member management interface
 * Now using unified components for consistent UI
 */

.member-list-container {
  padding: 24px;
  background:
    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),
    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

/* Management Container */
.members-management-container {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
  margin-bottom: 30px;
}

/* Loading */
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .member-list-container {
    padding: 16px;
  }
}

@media (max-width: 480px) {
  .member-list-container {
    padding: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/members/MemberList.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,aAAa;EACb;;;qDAGmD;EACnD,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,0CAA0C;EAC1C,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/**\n * Member List Styles\n * Modern, responsive member management interface\n * Now using unified components for consistent UI\n */\n\n.member-list-container {\n  padding: 24px;\n  background:\n    radial-gradient(circle at 20% 80%, rgba(102, 126, 234, 0.05) 0%, transparent 50%),\n    radial-gradient(circle at 80% 20%, rgba(118, 75, 162, 0.05) 0%, transparent 50%),\n    linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  min-height: 100vh;\n}\n\n/* Management Container */\n.members-management-container {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(20px);\n  border-radius: 20px;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n  margin-bottom: 30px;\n}\n\n/* Loading */\n.loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 400px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .member-list-container {\n    padding: 16px;\n  }\n}\n\n@media (max-width: 480px) {\n  .member-list-container {\n    padding: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
